module.exports = __webpack_public_path__ + "img/back.48d20b51.svg";